exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivideo[data-v-74d2766a]{    background-color: #252733;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n.ivideo>span[data-v-74d2766a]{color: #fff;\n    width: 80px;\n}\n.topicformat[data-v-74d2766a]{display:flex;justify-content: left;\n\tborder-bottom: 10px solid #fff;padding: 10px 0;\n}\n.SpecialSymbol[data-v-74d2766a]{width: 23%;display: inline-block;\n}\n.SpecialSymboltext[data-v-74d2766a]{width: 70%;\n}\n.SpecialSymbol>span[data-v-74d2766a]{color: red;\n}\n.otherbox[data-v-74d2766a]{padding: 10px 0 !important\n}\n.text-style[data-v-74d2766a]{text-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74d2766a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/voiceScene/partner.vue
// module id = 1511
// module chunks = 0